import type { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"
import type PatientConditionStateKey from "mco-keys/src/t4/PatientConditionStateKey"
import PatientConditionIssuesClient from "./PatientCondition.Issues.Client"

export type UpdatePatientConditionModel = {
	patientConditionUuid: string
	patientConditionId: number
	patientConditionStateKey: PatientConditionStateKey
	clientConditionId: string | null
	episodeNumber: string | null
	consentToShare: boolean
	ignoreValidationOnSave: boolean
}

class PatientConditionClient {
	constructor(private axiosClient: AxiosInstance) {
		this.issues = new PatientConditionIssuesClient(this.axiosClient)
	}

	public issues: PatientConditionIssuesClient

	public changeProblemArea = ({
		patientConditionId,
		newProblemArea
	}: {
		patientConditionUuid: string
		patientConditionId: number
		newProblemArea: string
	}) =>
		handleQueryResult(
			this.axiosClient.post<void>(
				`/api/admin/patientcondition/changecondition/${patientConditionId}?problemArea=${newProblemArea}`
			)
		)

	public activate = (patientConditionUuid: string) =>
		handleQueryResult(
			this.axiosClient.post(
				`/api/admin/patientcondition/activate/${patientConditionUuid}`
			)
		)

	public archive = (patientConditionUuid: string) =>
		handleQueryResult(
			this.axiosClient.post(
				`/api/admin/patientcondition/archive/${patientConditionUuid}`
			)
		)

	public update = (request: UpdatePatientConditionModel) =>
		this.axiosClient.post(`/api/admin/patientcondition/update`, request)
}

export default PatientConditionClient
